import React from "react";
import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { SITE } from "@/lib/site-config";

const FAQ = () => {
  return (
    <section
      id="faq"
      className="relative py-20 md:py-32 border-t border-[#556340]"
      data-testid="faq-section"
    >
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center max-w-3xl mx-auto"
        >
          <div className="text-[11px] font-bold uppercase tracking-[0.22em] text-[#E8E5D0] mb-4">
            Häufige Fragen
          </div>
          <h2 className="font-display text-4xl sm:text-5xl font-black tracking-tighter leading-[0.95]">
            Alles, was du wissen musst.
          </h2>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.1 }}
          className="mt-12"
        >
          <Accordion type="single" collapsible className="space-y-3">
            {SITE.faqs.map((f, idx) => (
              <AccordionItem
                key={idx}
                value={`item-${idx}`}
                className="bg-[#4E5A3B]/60 border border-[rgba(255,255,255,0.14)] rounded-xl px-5 data-[state=open]:border-[#E8E5D0]/40"
                data-testid={`faq-item-${idx}`}
              >
                <AccordionTrigger className="text-left text-[#F3F1E8] hover:no-underline font-display text-base sm:text-lg font-bold tracking-tight py-5 [&[data-state=open]>svg]:text-[#E8E5D0]">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-[#C9C6B4] leading-relaxed text-sm sm:text-base pb-5">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
};

export default FAQ;
